module.exports = __webpack_public_path__ + "static/img/honorBackground.6c4a64a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honorBackground.png
// module id = qMyu
// module chunks = 0